// extracted by mini-css-extract-plugin
export default {"trialLogoWrraper":"style_trialLogoWrraper__3ZhRk","contentWrraper":"style_contentWrraper__CvmFX","firstHead":"style_firstHead__McXQV","secondHead":"style_secondHead__+a8Ub"};